import styled, { BorderRadius, Color, css, Spacing, Font } from '@nfinite/react-hubstairs/styled'
import RoundPicture from 'components/Commons/RoundPicture'
import ButtonComponent from 'components/Commons/Button'
import TagComponent from 'components/Commons/Tag'
import IconComponent from 'components/Commons/Icon'

export const PICTURE_SIZE = 80

export const Container = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: ${Spacing.get('xs')}px;
  background-color: ${Color.get('gray', 'lighter')};
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  ${Spacing.generatePadding({ vertical: 'm' })}
  min-width: 160px;
  ${({ isActive }) =>
    isActive &&
    css`
      background-color: ${Color.get('white')} !important;
      border: 2px solid ${Color.get('primary')};
    `}
`

export const Organization = styled('div')`
  position: relative;
  height: ${PICTURE_SIZE}px;
  min-height: ${PICTURE_SIZE}px;
  width: ${PICTURE_SIZE}px;
  display: flex;
  justify-content: center;
  ${BorderRadius.generate({ all: 'm' })}
  overflow: hidden;
`

Organization.Picture = styled(RoundPicture)`
  width: ${PICTURE_SIZE}px;
  height: ${PICTURE_SIZE}px;
`

export const ActiveBadge = styled('div')`
  position: absolute;
  top: 10px;
  left: 12px;
  z-index: 20;
  background-color: ${Color.get('primary')};
  color: ${Color.get('white')};
  ${Spacing.generatePadding({ vertical: 'xxs', horizontal: 'xs' })}
  ${BorderRadius.generate({ all: 'xs' })}
  ${Font.generate({ size: 's', weight: 'mid' })}
`

export const Column = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${Spacing.get('xxs')}px;
  ${Spacing.generateMargin({ bottom: 's' })}
`

export const Name = styled('div')`
  ${Spacing.generateMargin({ top: 'xxs' })}
  ${Font.generate({ weight: 'mid' })};
`

export const ContractLabel = styled('div')`
  ${Font.generate({ size: 's', weight: 'mid' })};
`

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: space-between;
`

export const PlaceholderContainer = styled(Container)`
  background-color: ${Color.get('gray', 'light')};
  cursor: default;
  height: auto;
`

export const PlaceholderCircle = styled('div')`
  width: 80px;
  height: 80px;
  min-height: 80px;
  ${BorderRadius.generate({ all: 'round' })}
`

export const PlaceholderBar = styled('div')`
  height: 14px;
  ${BorderRadius.generate({ all: 'l' })}
`

export const PlaceholderTag = styled('div')`
  height: 24px;
  width: 80px;
  ${BorderRadius.generate({ all: 'l' })}
`

export const SwitchButton = styled(ButtonComponent)`
  max-height: 30px;
`

export const TagNoCapitalize = styled(TagComponent)`
  text-transform: none;
  ${Spacing.generatePadding({ horizontal: 'm' })}
`

export const ArrowIcon = styled(IconComponent)`
  width: 10px;
  height: 10px;
  transform: rotate(180deg);
`
